import {Checkbox} from "antd";
import React from "react";
import styles from "./CampaignDaysInput.module.css";

// Gün isimleri ve karşılık gelen sayısal değerler
const DAY_NAMES = ["Pazartesi", "Salı", "Çarşamba", "Perşembe", "Cuma", "Cumartesi", "Pazar"];
const DAY_VALUES = [1, 2, 3, 4, 5, 6, 7];

export const CampaignDaysInput = ({value = [], setValue, disabled = false}) => {
    const handleChange = dayValue => {
        if (disabled) return;

        if (value.includes(dayValue)) {
            setValue(value.filter(d => d !== dayValue));
        } else {
            setValue([...value, dayValue]);
        }
    };

    return (
        <div className={styles.container}>
            <div className={styles.daysContainer}>
                {DAY_NAMES.map((dayName, index) => {
                    const dayValue = DAY_VALUES[index];
                    const isChecked = value.includes(dayValue);
                    return (
                        <div
                            key={index}
                            className={`${styles.dayItem} ${
                                isChecked ? styles.dayItemChecked : ""
                            }`}
                            onClick={() => handleChange(dayValue)}
                        >
                            <Checkbox
                                checked={isChecked}
                                disabled={disabled}
                                onChange={e => {
                                    e.stopPropagation();
                                    handleChange(dayValue);
                                }}
                            />
                            <span
                                className={styles.dayText}
                                onClick={e => {
                                    e.stopPropagation();
                                    handleChange(dayValue);
                                }}
                            >
                                {dayName}
                            </span>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};
